export enum TourName {
  ONBOARDING = 'onboarding',
}

export enum TourStyleTypes {
  BANNER = 'banner',
  ARROW = 'arrow',
  MATMANIMAGE = 'matManImage',
}

export enum TourArrowTypes {
  STRAIGHT = 'straight',
  CURVED = 'curved',
}

export enum TourSteps {
  WELCOME = 'welcome',
  MAT_MAN_ICON = 'matManIcon',
  LETTER_BOOKS = 'letterBooks',
  ASSIGNMENTS = 'assignments',
  GREAT_ALPHABET_PARADE = 'greatAlphabetParade',
  REWARDS = 'rewards',
}
